import React, {
  createContext, useContext, useState, useEffect,
} from 'react'

import { authenticateUser } from '@services/auth.service'

const AuthContext = createContext()

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const authenticatedUser = await authenticateUser()
        setUser(authenticatedUser)
      }
      catch {
        setUser(null)
      }
      finally {
        setIsLoading(false)
      }
    }

    fetchUser()

    // Set up interval for cookie if removed
    const intervalId = setInterval(() => {
      const hasCookie = document.cookie.includes('cognito=')
      if (!hasCookie) {
        setUser(null)
      }
    }, 5000) // Check every 5 seconds

    return () => clearInterval(intervalId) // Clean up interval
  }, [])

  return (
    <AuthContext.Provider value={{ user, setUser, isLoading }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
